import React from "react";

const QuestionnaireMultipleSelect = (props) => {
  return (
    <div className="flex gap-2 flex-wrap" {...props}>
      {props?.array?.map((item, index) => (
        <div
          key={index}
          className={`questionnaire-multiple-select ${
            props?.value?.includes(item)
              ? "bg-main text-white"
              : "bg-white text-gray text-opacity-70"
          }`}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default QuestionnaireMultipleSelect;
